import baseURL from '../api/url'

export const fetchPushNotificationsURL = `${baseURL.CONFIG_URL}/catalogadmin/notifications/fetch`
export const updatePushNotificationsURL = `${baseURL.CONFIG_URL}/catalogadmin/notifications/update`
export const createPushNotificationURL = `${baseURL.CONFIG_URL}/catalogadmin/notifications/create`
export const deletePushNotificationURL = `${baseURL.CONFIG_URL}/catalogadmin/notifications/delete`
export const publishPushNotificationURL = `${baseURL.CONFIG_URL}/catalogadmin/notifications/publish`
export const unPublishPushNotificationURL = `${baseURL.CONFIG_URL}/catalogadmin/notifications/unpublish`
export const getUsersURL = `${baseURL.CONFIG_URL}/catalogadmin/notifications/user/fetch`
export const getDMAList = `${baseURL.SEVEN_NOW_CORE_API_URL}/location/v1/dma`
